"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _editor = require("composer-lib/redux/actions/editor");

var _actions = require("composer-lib/redux/actions");

var _AppState = _interopRequireDefault(require("composer-lib/data/model/AppState"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _helpers = require("composer-lib/lib/helpers");

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("composer-lib/lib/utils");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _Pages = _interopRequireDefault(require("composer-lib/data/model/Pages"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _composer = require("composer-lib/redux/actions/composer");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _draftExtend = require("draft-extend");

var _editorConfigs = require("composer-lib/lib/editorConfigs");

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    app: state.app,
    auth: state.auth,
    composerSettings: state.composerSettings,
    composition: state.composition,
    conversations: state.conversations,
    lock: state.lock,
    pages: state.pages,
    presence: state.presence,
    saveState: state.save,
    users: state.users
  };
};

var mapDispatchToProps = {
  addToast: _actions.addToast,
  insertImage: _editor.insertImage,
  insertEmbed: _editor.insertEmbed,
  insertableLoaded: _editor.insertableLoaded,
  insertVideo: _editor.insertVideo,
  insertQuestionAndAnswer: _editor.insertQuestionAndAnswer,
  saveComposition: _composer.saveComposition,
  setBodyEditorActive: _actions.setBodyEditorActive,
  setEditorLoaded: _actions.setEditorLoaded,
  updateContentToSave: _composer.updateContentToSave
};
var ComposerToolbar = (0, _createReactClass.default)({
  displayName: "ComposerToolbar",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    addKeyCommandListener: _propTypes.default.func.isRequired,
    app: _propTypes.default.instanceOf(_AppState.default).isRequired,
    auth: _propTypes.default.object,
    className: _propTypes.default.string,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    handleKeyCommand: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    pages: _propTypes.default.instanceOf(_Pages.default).isRequired,
    removeKeyCommandListener: _propTypes.default.func.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    updateContentToSave: _propTypes.default.func.isRequired,
    properties: _propTypes.default.instanceOf(_immutable.Map),
    saveQuestion: _propTypes.default.func
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.updateHelpers = (0, _helpers.makeComposerHelperUpdater)(this, [_helpers.ComposerHelperNames.ON_INSERT_IMAGE_CHANGE, _helpers.ComposerHelperNames.ON_INSERT_VIDEO_CHANGE, _helpers.ComposerHelperNames.ON_INSERT_EMBED_CHANGE, _helpers.ComposerHelperNames.ON_INSERT_QUESTION_AND_ANSWER]);
    this.updateHelpers();
    this.buildToolbar();
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateHelpers(nextProps);

    if (this.shouldUpdateToolbar(nextProps)) {
      this.buildToolbar();
    }
  },
  getPages: function getPages() {
    return (0, _utils.getMemoizedPages)(this.props.pages);
  },
  shouldUpdateToolbar: function shouldUpdateToolbar(nextProps) {
    return nextProps.properties && !nextProps.properties.equals(this.props.properties) || nextProps.saveQuestion !== this.props.saveQuestion;
  },
  buildToolbar: function buildToolbar() {
    var _this$props = this.props,
        composition = _this$props.composition,
        composerSettings = _this$props.composerSettings,
        properties = _this$props.properties,
        saveQuestion = _this$props.saveQuestion;
    var props = {
      properties: properties,
      saveQuestion: saveQuestion,
      originId: composition.getIn(['data', 'originId'])
    };
    this.ToolbarWithPlugins = (0, _editorConfigs.toolbarConfig)(composerSettings.richTextStyles, composerSettings.features, composerSettings.betas, {
      getPages: this.getPages,
      fileManagerUploadedFileAccess: composerSettings.fileManagerUploadedFileAccess,
      props: props
    })(_draftExtend.Toolbar);
  },
  render: function render() {
    var _this$props2 = this.props,
        addKeyCommandListener = _this$props2.addKeyCommandListener,
        app = _this$props2.app,
        auth = _this$props2.auth,
        className = _this$props2.className,
        composition = _this$props2.composition,
        handleKeyCommand = _this$props2.handleKeyCommand,
        lock = _this$props2.lock,
        removeKeyCommandListener = _this$props2.removeKeyCommandListener,
        saveState = _this$props2.saveState;

    if (!saveState.content || (0, _lockHelpers.compositionLocked)(lock, auth, saveState) || composition.isReadOnly()) {
      return null;
    }

    var classes = (0, _classnames.default)('composer-formatting-bar', (0, _defineProperty2.default)({}, className, className));
    var disabled = !app.bodyActive;

    var disabledTooltip = _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.composer.toolbarDisabled"
    });

    return _react.default.createElement(_UITooltip.default, {
      open: disabled ? undefined : false,
      title: disabledTooltip,
      placement: "bottom"
    }, _react.default.createElement("div", {
      className: classes
    }, _react.default.createElement(this.ToolbarWithPlugins, {
      addKeyCommandListener: addKeyCommandListener,
      auth: auth,
      disabled: disabled,
      editorState: saveState.content,
      handleKeyCommand: handleKeyCommand,
      onChange: this.props.updateContentToSave,
      onInsertImage: this.onInsertImageChange,
      onInsertVideo: this.onInsertVideoChange,
      onInsertEmbed: this.onInsertEmbedChange,
      onInsertQuestionAndAnswerChange: this.onInsertQuestionAndAnswerChange,
      removeKeyCommandListener: removeKeyCommandListener
    })));
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ComposerToolbar);

exports.default = _default;
module.exports = exports.default;